(function () {
  const overlay = document.getElementById('bisModalOverlay');
  if (!overlay) return;

  const modal = overlay.querySelector('.bis-modal');
  const openBtn = document.getElementById('bisOpenBtn');
  const closeBtn = document.getElementById('bisCloseBtn');

  const sizeSelect = document.getElementById('bisSizeSelect');
  const emailInput = document.getElementById('bisEmail');
  const phoneInput = document.getElementById('bisPhone');
  const consentWrap = document.getElementById('bisConsentWrap');
  const consentCheckbox = document.getElementById('bisSmsConsent');
  const submitBtn = document.getElementById('bisSubmit');
  const statusEl = document.getElementById('bisStatus');

  // These are injected by Liquid
  const BIS = window.__BIS__ || {};
  const product = BIS.product;
  const endpoint = BIS.endpoint; // secure endpoint you control
  const privacyUrl = BIS.privacyUrl || '/policies/privacy-policy';

  function getSelectedVariantIdFromDawn() {
    // Dawn usually keeps current variant id in the product form input[name="id"]
    const form = document.querySelector('form[action="/cart/add"]');
    const idInput = form && form.querySelector('input[name="id"]');
    return idInput && idInput.value ? Number(idInput.value) : null;
  }

  function getVariantById(variantId) {
    return product?.variants?.find(v => Number(v.id) === Number(variantId)) || null;
  }

  function getSoldOutVariants() {
    return (product?.variants || []).filter(v => !v.available);
  }

  function populateSizeDropdown() {
    const soldOut = getSoldOutVariants();

    sizeSelect.innerHTML = '';
    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Select size';
    sizeSelect.appendChild(placeholder);

    soldOut.forEach(v => {
      const opt = document.createElement('option');
      opt.value = String(v.id);
      // show "S" / "M" etc: use variant title
      opt.textContent = v.title;
      sizeSelect.appendChild(opt);
    });

    // Default to currently selected variant if sold out
    const selectedVariantId = getSelectedVariantIdFromDawn();
    if (selectedVariantId) {
      const selectedVariant = getVariantById(selectedVariantId);
      if (selectedVariant && !selectedVariant.available) {
        sizeSelect.value = String(selectedVariant.id);
      }
    }
  }

  function showOpenButtonIfSelectedSoldOut() {
    const vid = getSelectedVariantIdFromDawn();
    const v = vid ? getVariantById(vid) : null;

    if (v && !v.available) {
      openBtn.classList.remove('bis-hidden');
    } else {
      openBtn.classList.add('bis-hidden');
      closeModal();
    }
  }

  function openModal() {
    populateSizeDropdown();
    statusEl.textContent = '';
    submitBtn.disabled = false;

    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden');

    // Focus
    setTimeout(() => emailInput.focus(), 50);
  }

  function closeModal() {
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden');
  }

  function setConsentVisibility() {
    const hasPhone = (phoneInput.value || '').trim().length > 0;
    consentWrap.style.display = hasPhone ? 'flex' : 'none';
    if (!hasPhone) consentCheckbox.checked = false;
  }

  function validEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
  }

  async function submit() {
    const variantId = sizeSelect.value ? Number(sizeSelect.value) : null;
    const email = (emailInput.value || '').trim();
    const phone = (phoneInput.value || '').trim();
    const smsConsent = !!consentCheckbox.checked;

    if (!variantId) {
      statusEl.textContent = 'Please select a size.';
      return;
    }
    if (!validEmail(email)) {
      statusEl.textContent = 'Please enter a valid email address.';
      return;
    }
    if (phone && !smsConsent) {
      statusEl.textContent = 'Please check the SMS consent box to receive texts.';
      return;
    }

    const variant = getVariantById(variantId);
    if (!variant) {
      statusEl.textContent = 'Something went wrong. Please refresh and try again.';
      return;
    }

    submitBtn.disabled = true;
    statusEl.textContent = 'Submitting…';

    const payload = {
      email,
      phone: phone || null,
      sms_consent: smsConsent,
      list_id: window.__BIS__.listId,
      product: {
        id: product.id,
        title: product.title,
        handle: product.handle,
        url: `${window.location.origin}/products/${product.handle}`
      },
      variant: {
        id: variant.id,
        title: variant.title
      },
      // optional: helpful metadata for you
      school: BIS.school || null,
      source: 'shopify_bis_modal',
      privacy_url: privacyUrl
    };

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        const txt = await res.text();
        throw new Error(txt || 'Request failed');
      }
      

      statusEl.textContent = 'You’re on the list. We’ll notify you when it’s back.';
      submitBtn.disabled = true;

      // optional: close after a second
      // setTimeout(closeModal, 1200);
    } catch (e) {
      console.error(e);
      statusEl.textContent = 'Sorry — something went wrong. Please try again.';
      submitBtn.disabled = false;
    }
  }

  // Events
  openBtn.addEventListener('click', openModal);
  closeBtn.addEventListener('click', closeModal);

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeModal();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeModal();
  });

  phoneInput.addEventListener('input', setConsentVisibility);
  sizeSelect.addEventListener('change', () => { statusEl.textContent = ''; });
  submitBtn.addEventListener('click', (e) => { e.preventDefault(); submit(); });

  // Dawn variant change hook (works with most Dawn builds)
  document.addEventListener('change', (e) => {
    // Any change in variant selectors should re-check
    const form = document.querySelector('form[action="/cart/add"]');
    if (form && form.contains(e.target)) {
      showOpenButtonIfSelectedSoldOut();
    }
  });

  // init
  setConsentVisibility();
  showOpenButtonIfSelectedSoldOut();
})();
